import { Component, OnInit } from '@angular/core';
import { forkJoin, of } from 'rxjs';
import { ComparatorRepository } from 'src-ironside/repositories/comparator.repository';
import { Product } from 'src-ironside/repositories/product.repository';
import { Resource, ResourceRepository } from 'src-ironside/repositories/resource.repository';

@Component({
    selector: 'app-comparator',
    templateUrl: './comparator.component.html',
    styleUrls: ['./comparator.component.css'],
    providers:[ResourceRepository]
})
export class ComparatorComponent implements OnInit {
    products?: Product[];

    constructor(private comparatorRepository: ComparatorRepository, private resourceRepository: ResourceRepository) {}

    ngOnInit(): void {
        this.comparatorRepository.getMyComparators().subscribe((res) => {
            const result = res.map(el=>({
                resources:el.linkToRessources?.map(resource => resource.documentId),
                id:el?.id,
                title:el?.shortDescription?.fr_FR
            }))
            this.products =this.fetchImageProduct(result);
        });
    }

    fetchImageProduct(products: Product[]) {
        const productGroups = [];

        for (let i = 0; i < products.length; i += 10) {
            productGroups.push(products.slice(i, i + 10));
        }

        const observables = productGroups.map((group) => {
            const resourceIds = group.flatMap((product) => product.resources || []);
            return resourceIds.length
                ? this.resourceRepository.getListImageResource(resourceIds)
                : of([]);
        });

        forkJoin(observables).subscribe((results) => {
            const combinedImages = results.flatMap((item) => item);

            products.forEach((product) => {
                const matchingImage: Resource | undefined = combinedImages.find(
                    (image) => image?.id === product?.resources?.[0]
                );

                if (matchingImage) {
                    product.image = matchingImage?.files?.[0]?.url || '';
                }
            });
        });
        return products;
    }

    deleteProduct(productId?: string) {
        if (!productId) return;
        this.comparatorRepository.deleteProduct([productId]);
    }
}
